import { Typography } from '@mui/material'

// imgae
import imgDeviceTec from '../../assets/01_Advantages/01設備聯網技術.png'
import imgSmartMngm from '../../assets/01_Advantages/02智慧生產管理.png'
import imgRepoEyes from '../../assets/01_Advantages/03遠端監控與預警.png'
import React from 'react'
import  useRWD from '../../utils/useRWD'

const introContent = [
  {
    title: '設備聯網技術',
    descipt: [
      <Typography variant="body1" align="left">
        整合採集機台資訊，打造完整數據採集與監控系統。
      </Typography>,
      <Typography variant="body1" align="left">
        –Sensor 感測器
      </Typography>,
      <Typography variant="body1" align="left" style={{ marginLeft: '0.5em' }}>
        即時擷取關鍵機台數據（溫度、壓力、振動等）
      </Typography>,
      <Typography variant="body1" align="left">
        –CNC / PLC 數據採集：
      </Typography>,
      <Typography variant="body1" align="left" style={{ marginLeft: '0.5em' }}>
        支援 Fanuc、Siemens、Mitsubishi 等品牌控制器，確保完整數據記錄。
      </Typography>,
    ],
    imgSrc: imgDeviceTec,
  },
  {
    title: '智慧生產管理',
    descipt: [
      <Typography align="left">–一站式智慧分析平台：</Typography>,
      <Typography align="left" style={{ marginLeft: '0.5em' }}>
        可視化工廠設備生產狀態，提供數據報表與即時監控介面。
      </Typography>,
      <Typography align="left">–設備監控系統：</Typography>,
      <Typography align="left" style={{ marginLeft: '0.5em' }}>
        提供歷史數據堆疊圖、警報履歷查詢、稼動率分析。
      </Typography>,
      <Typography align="left">–刀具壽命履歷管理：</Typography>,
      <Typography align="left" style={{ marginLeft: '0.5em' }}>
        追蹤刀具使用歷程，根據數據計算更換週期，減少生產中斷。
      </Typography>,
    ],
    imgSrc: imgSmartMngm,
  },
  {
    title: '遠端監控與預警',
    descipt: [
      <Typography align="left">–設備監控系統：</Typography>,
      <Typography align="left" style={{ marginLeft: '0.5em' }}>
        提供歷史數據堆疊圖、警報履歷查詢、稼動率分析。
      </Typography>,
      <Typography align="left">
        –即時掌握設備運行狀況，降低停機風險，提高產能。
      </Typography>,
      <Typography align="left">–AI 刀具診斷：</Typography>,
      <Typography align="left" style={{ marginLeft: '0.5em' }}>
        透過 AI 分析刀具磨損情況，提前預測更換時機，降低刀具損壞風險與維護成本。
      </Typography>,
    ],
    imgSrc: imgRepoEyes,
  },
]

export default function IntroCard() {
  return (
    <>
      {introContent?.map((item, i) => (
        <Card key={i} id={i} {...item} />
      ))}
    </>
  )
}

function Card({ ...props }) {
  const { title, descipt, imgSrc, id } = props
  const isPlural = Number(id) % 2 === 0
  const { isPC, isToplet, isPhone } = useRWD()
  return (
    <>
      {isPC ? (
        <div
          style={{
            display: 'flex',
            flexDirection: isPC ? 'row' : 'column',
            alignItems: 'center',
            gap: '1em',
            justifyContent: 'center',
          }}
        >
          {!isPlural ? (
            <>
              <div style={{ width: '30%' }}>
                <img src={imgSrc} alt={title} style={{ width: '100%' }} />
              </div>
              <div style={{ width: 'auto' }}>
                <Typography
                  variant="h4"
                  align="left"
                  style={{ marginBottom: '0.4em' }}
                >
                  {title}
                </Typography>
                {descipt.map((item, i) => (
                  <React.Fragment key={i}>{item}</React.Fragment>
                ))}
              </div>
            </>
          ) : (
            <>
              <div style={{ width: 'auto' }}>
                <Typography
                  variant="h4"
                  align="left"
                  style={{ marginBottom: '0.4em' }}
                >
                  {title}
                </Typography>
                {descipt.map((item, i) => (
                  <React.Fragment key={i}>{item}</React.Fragment>
                ))}
              </div>
              <div style={{ width: '30%' }}>
                <img src={imgSrc} alt={title} style={{ width: '100%' }} />
              </div>
            </>
          )}
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom: '3rem'
          }}
        >
          <div style={{ width: '50%' }}>
            <img src={imgSrc} alt={title} style={{ width: '100%' }} />
          </div>
          <div style={{ width: 'auto' }}>
            <Typography
              variant="h4"
              align="left"
              style={{ marginBottom: '0.4em' }}
            >
              {title}
            </Typography>
            {descipt.map((item, i) => (
              <React.Fragment key={i}>{item}</React.Fragment>
            ))}
          </div>
        </div>
      )}
    </>
  )
}
